<template>
  <span class="is-relative" @click="$emit('click')">
    <slot/>

    <span v-if="hideData" class="sensitive_data"></span>
  </span>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "SensitiveDataWrapper",
  computed: {
    hideData() {
      return this.$store.getters.account.has_sensitive_data_ability && this.$store.getters.authUser.hide_sensitive_data
    }
  },
})
</script>

<style scoped lang="scss">
.sensitive_data {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  backdrop-filter: blur(5px);
}
</style>
